import { extractNestJsErrorMessage, REFETCH_TIME_SPAN } from 'shared/api/rtk-query';
import { purchaseApi } from './purchase.api';
import { UpdatePurchaseDto } from '@sr/dto';

export const usePurchase = (id: number) => {
  const { data, isLoading, error, refetch } = purchaseApi.useGetPurchaseQuery(id, { refetchOnMountOrArgChange: REFETCH_TIME_SPAN });
  const [update] = purchaseApi.useUpdatePurchaseMutation();

  return {
    purchase: data,
    updatePurchase: async (dto: UpdatePurchaseDto) => {
      return update(dto).unwrap();
    },
    reload: () => refetch(),
    error: extractNestJsErrorMessage(error),
    isLoading
  };
};
